import { ReactNode } from 'react';

import { Field, FieldProps, FieldRenderProps } from 'react-final-form';

import { SwitchInput as Input } from '@vk-hr-tek/ui/input';

/**
 * Свойства компонента {@link SwitchInput}
 */
interface SwitchInputProps {
  /**
   * Текст подписи к переключателю.
   */
  label: string;

  /**
   * Иконка для метки.
   */
  labelIcon?: ReactNode;

  /**
   * Функция обратного вызова при изменении состояния переключателя.
   */
  onChange?: (check: boolean) => void;

  /**
   * Флаг, указывающий, отключен ли переключатель.
   */
  disabled?: boolean;

  /**
   * Расположение подписи относительно переключателя.
   */
  labelPlacement?: 'start' | 'end';
}

/**
 * Компонент переключателя с подписью.
 *
 * @public
 * @param label - Текст подписи к переключателю.
 * @param labelIcon - Иконка для метки.
 * @param onChange - Функция обратного вызова при изменении состояния переключателя.
 * @param disabled - Флаг, указывающий, отключен ли переключатель.
 * @param labelPlacement - Расположение подписи относительно переключателя.
 * @param tooltip - Текст всплывающей подсказки.
 * @param rest - Остальные пропсы, передаваемые в {@link Field}.
 * @returns Компонент переключателя.
 *
 * @remarks
 *
 * Ссылка на свойства компонента {@link SwitchInputProps}
 */
export const SwitchInput = ({
  label,
  labelIcon,
  onChange,
  disabled,
  labelPlacement,
  tooltip,
  ...rest
}: SwitchInputProps &
  FieldProps<boolean | undefined, FieldRenderProps<boolean | undefined>>) => {
  return (
    <Field {...rest}>
      {({ input }) => {
        return (
          <Input
            {...input}
            checked={!!input.value}
            label={label}
            labelIcon={labelIcon}
            onChange={(check) => {
              input.onChange(check);
              if (onChange) {
                onChange(check);
              }
            }}
            disabled={disabled}
            labelPlacement={labelPlacement}
            tooltip={tooltip}
          />
        );
      }}
    </Field>
  );
};
